// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../../shared/action-creator/alert-messages';
import {
    getAtpTransLog,
    getAtpTransLogCriteria,
    getRellocationLog, getRellocationLogCriteria, getTransLog, getTransLogCriteria
} from './repositories';
import Breadcrumbs from '../../../common/components/bread-crumbs';
import BusyCounterLoadingIndicator from '../../../shared/components/busyCounter/busy-counter-loading-indicator';
import LabeledInput from '../../../shared/components/labeled-input';
import OptionsDropDown from '../../../shared/components/options-drop-down';
import OrderInformation from '../../information/orderInformation';
import PropTypes from 'prop-types';
import TransactionReallocationLogTable from './components/transaction-reallocation-log-table';
// import SelectList from '../../../shared/components/options-drop-down/select-list';
import { connect } from 'react-redux';
import { formatGivenDate } from '../../../shared/services/common-functions';
import { showLoadingIndicator } from '../../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class TransactionRellocationLog extends Component {

    state = {
        criteria: {},
        selectedDate: 0,
        selectedAct: '',
        selectedDrc: '',
        selectedFrc: '',
        selectedBuildWeek: 0,
        selectedAttachment: '',
        selectedRetInd: '',
        order: '',
        model: '',
        results: null,
        selectedOrderNumber: 0,
        selectedtransNumber: 0
    };

    componentDidMount = () => {

        const query = new URLSearchParams( this.props.location.search );
        const queryOrderNum = query.get( 'ordernumber' );

        if ( this.props.transactionLog ) {

            this.props.increaseCounter();
            if ( this.props.deereAtp ) {

                getAtpTransLogCriteria( ).then( resp => {

                    this.setState( {
                        criteria: {
                            ...resp,
                            attachment: resp.family,
                            buildWeek: resp.buildWeeks
                        },
                        order: queryOrderNum || ''
                    } );
                    const defDate = ( resp.transDate
                                && resp.transDate.length > 0 ) ? resp.transDate[0] : '';
                    if ( defDate ) this.setState( { selectedDate: defDate } );
                    this.onFilterSearch();
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            } else {

                getTransLogCriteria( ).then( response => {

                    this.setState( {
                        criteria: response,
                        selectedAttachment: 'NO',
                        order: queryOrderNum || ''
                    } );
                    const defDate = ( response && response.transDate
                        && response.transDate.length > 0 ) ? response.transDate[0] : '';
                    if ( defDate ) this.setState( { selectedDate: defDate } );
                    this.onFilterSearch();
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

        } else {

            this.props.increaseCounter();
            getRellocationLogCriteria( ).then( response => {

                this.setState( {
                    criteria: response,
                    selectedAttachment: 'NO',
                    order: queryOrderNum || ''
                } );
                const defDate = ( response && response.transDate
                    && response.transDate.length > 0 ) ? response.transDate[0] : '';
                if ( defDate ) this.setState( { selectedDate: defDate } );
                this.onFilterSearch();
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        }

    }

    handleDropdownChange ( name, val ) {

        this.setState( {
            [`selected${name}`]: val
        }, () => {

            // this.onFilterSearch();

        } );

    }

    handleTextChange ( name, val ) {

        this.setState( {
            [`${name}`]: val.target.value
        }, () => {

            // this.onFilterSearch();

        } );

    }

    onClear () {

        const { criteria } = this.state;
        const defDate = ( criteria && criteria.transDate
            && criteria.transDate.length > 0 ) ? criteria.transDate[0] : '';
        this.setState( {
            selectedDate: defDate || 0,
            selectedAct: '',
            selectedDrc: '',
            selectedFrc: '',
            selectedBuildWeek: 0,
            selectedAttachment: 'NO',
            selectedRetInd: '',
            order: '',
            model: '',
            results: null
        } );

    }

    onSelectOrderNumber ( orderNumber, transNumber ) {

        this.setState( {
            selectedOrderNumber: orderNumber,
            selectedtransNumber: transNumber
        } );

    }

    onFilterSearch () {

        this.props.increaseCounter();
        if ( this.state.selectedDate === 0 ) {

            this.setState( {
                results: []
            } );
            this.props.decreaseCounter();
            return;

        }
        this.props.decreaseCounter();
        let payload = {
            transDate: this.state.selectedDate === '-1' ? '' : this.state.selectedDate,
            act: this.state.selectedAct,
            drc: this.state.selectedDrc,
            frc: this.state.selectedFrc,
            order: this.state.order,
            buildWeek: this.state.selectedBuildWeek,
            // attachementOnly
            retInd: this.state.selectedRetInd
        };
        if ( this.props.deereAtp ) {

            payload = {
                ...payload,
                buildWeek: this.state.selectedBuildWeek ? formatGivenDate( parseInt( this.state.buildWeek, 10 ), 'YYYY-MM-DD' ) : '',
                transDate: formatGivenDate( parseInt( this.state.selectedDate === '-1' ? '' : this.state.selectedDate, 10 ), 'YYYY-MM-DD' ),
                buildMach: this.state.model,
                family: this.state.selectedAttachment
            };

        } else {

            payload = {
                ...payload,
                model: this.state.model,
                attachementOnly: this.state.selectedAttachment
            };

        }
        if ( this.props.transactionLog ) {

            this.props.increaseCounter();
            if ( this.props.deereAtp && this.state.selectedDate !== '' && this.state.selectedDate !== 0 ) {

                getAtpTransLog( payload )
                    .then( response => {

                        const processResult = [...response].map( i => ( i ? {
                            ...i,
                            buildWeekString: formatGivenDate( i.buildWeek, 'YYYY-MM-DD' ),
                            rddString: formatGivenDate( i.rdd, 'YYYY-MM-DD' ),
                            updatedDateString: formatGivenDate( i.updatedDate, 'YYYY-MM-DD HH:mm:ss' )
                        } : i ) );

                        this.setState( {
                            results: processResult
                        } );
                        this.props.decreaseCounter();

                    } ).catch( () => {

                        this.props.decreaseCounter();

                    } );

            } else {

                getTransLog( payload )
                    .then( response => {

                        const processResult = [...response].map( i => ( i ? {
                            ...i,
                            buildWeekString: formatGivenDate( i.buildWeek, 'YYYY-MM-DD' ),
                            reqDeliveryDateString: formatGivenDate( i.reqDeliveryDate, 'YYYY-MM-DD' ),
                            transDateString: formatGivenDate( i.transDate, 'YYYY-MM-DD' ),
                            transTimeString: formatGivenDate( i.transTime, 'hh:mm:ss a' )
                        } : i ) );

                        this.setState( {
                            results: processResult
                        } );
                        this.props.decreaseCounter();

                    } ).catch( () => {

                        this.props.decreaseCounter();

                    } );

            }

        } else {

            this.props.increaseCounter();
            getRellocationLog( payload )
                .then( response => {

                    const processResult = [...response].map( i => ( i ? {
                        ...i,
                        expectedWarehouseDateString: formatGivenDate( i.expectedWarehouseDate, 'YYYY-MM-DD' ),
                        orgExpectedWarehouseDateString: formatGivenDate( i.orgExpectedWarehouseDate, 'YYYY-MM-DD' ),
                        transDateString: formatGivenDate( i.transDate, 'YYYY-MM-DD' ),
                        transTimeString: formatGivenDate( i.transTime, 'hh:mm:ss a' )
                    } : i ) );

                    this.setState( {
                        results: processResult
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

        }

    }

    render () {

        const { transactionLog, deereAtp } = this.props;
        const {
            criteria, selectedDate, selectedAct, order, model,
            selectedDrc, selectedFrc, selectedBuildWeek,
            selectedRetInd, selectedAttachment, results, selectedOrderNumber, selectedtransNumber
        } = this.state;
        const {
            transDate, activityType, dealerRespCode,
            factoryRespCode, buildWeek, attachment, retailInd
        } = criteria;

        const dates = transDate ? transDate.map( date => ( { label: formatGivenDate( date, 'YYYY-MM-DD' ), id: date } ) ) : [];
        const newBuildWeek = buildWeek ? buildWeek.map( bw => ( {

            // id: new Date( bw ).toISOString().substring( 0, 10 )
            id: bw,
            label: formatGivenDate( bw, 'YYYY-MM-DD' )

        } ) ) : [];
        const crumbs = [{
            link: '',
            text: 'ATP Transaction Log'
        }, {
            link: `/${this.props.unit.name}/constraints/constraint-violations-by-order?ordernum=${selectedOrderNumber}`,
            text: 'Constraint Violations By Order'
        }];

        let pageHeading = transactionLog ? 'Transaction Log' : 'Reallocation Log';
        pageHeading = deereAtp ? 'ATP Transaction' : pageHeading;

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">{pageHeading}</h2>
                </header>

                <main>
                    { selectedOrderNumber === 0 && (
                        <section className="section-container">
                            <div className="atp-top-options atp-transaction-log-top-options">
                                { criteria.transDate && (
                                    <div className="select-options">
                                        <OptionsDropDown
                                            className="date"
                                            label={transactionLog ? 'Trans Date' : 'Date'}
                                            isPlaceholderTranslated={true}
                                            onChange={this.handleDropdownChange.bind( this, 'Date' )}
                                            optionDisplayAttributes={['label']}
                                            optionKey="id"
                                            options={dates}
                                            placeholder=""
                                            selectedValue={selectedDate}
                                            isRequired={false}
                                        />
                                        <OptionsDropDown
                                            className="act"
                                            label="ACT"
                                            isPlaceholderTranslated={true}
                                            onChange={this.handleDropdownChange.bind( this, 'Act' )}
                                            optionDisplayAttributes={['value']}
                                            optionKey="id"
                                            options={activityType}
                                            placeholder=""
                                            selectedValue={selectedAct}
                                            isRequired={false}
                                        />
                                        <OptionsDropDown
                                            className="drc"
                                            label="DRC"
                                            isPlaceholderTranslated={true}
                                            onChange={this.handleDropdownChange.bind( this, 'Drc' )}
                                            optionDisplayAttributes={['value']}
                                            optionKey="id"
                                            options={dealerRespCode}
                                            placeholder=""
                                            selectedValue={selectedDrc}
                                            isRequired={false}
                                        />
                                        <OptionsDropDown
                                            className="frc"
                                            label="FRC"
                                            isPlaceholderTranslated={true}
                                            onChange={this.handleDropdownChange.bind( this, 'Frc' )}
                                            optionDisplayAttributes={['value']}
                                            optionKey="id"
                                            options={factoryRespCode}
                                            placeholder=""
                                            selectedValue={selectedFrc}
                                            isRequired={false}
                                        />
                                        <LabeledInput
                                            className="order"
                                            name="Order"
                                            isEditable={true}
                                            label="Order"
                                            maxLength={12}
                                            onChange={this.handleTextChange.bind( this, 'order' )}
                                            value={order}
                                            isRequired={false}
                                        />
                                        <OptionsDropDown
                                            className="build-week"
                                            label="Build Week"
                                            isPlaceholderTranslated={true}
                                            onChange={this.handleDropdownChange.bind( this, 'BuildWeek' )}
                                            optionDisplayAttributes={['label']}
                                            optionKey="id"
                                            options={newBuildWeek}
                                            placeholder=""
                                            selectedValue={selectedBuildWeek}
                                            isRequired={false}
                                        />
                                        <LabeledInput
                                            className="model"
                                            name="model"
                                            isEditable={true}
                                            label={deereAtp ? 'Base Machine' : 'Model'}
                                            maxLength={12}
                                            onChange={this.handleTextChange.bind( this, 'model' )}
                                            value={model}
                                            isRequired={false}
                                        />
                                        <OptionsDropDown
                                            className="attachment"
                                            label={deereAtp ? 'Family' : 'Attachment Only'}
                                            isPlaceholderTranslated={true}
                                            onChange={this.handleDropdownChange.bind( this, 'Attachment' )}
                                            optionDisplayAttributes={['value']}
                                            optionKey="id"
                                            options={attachment}
                                            placeholder=""
                                            selectedValue={selectedAttachment}
                                            isRequired={false}
                                        />
                                        <OptionsDropDown
                                            className="ret-ind"
                                            label="Ret Ind"
                                            isPlaceholderTranslated={true}
                                            onChange={this.handleDropdownChange.bind( this, 'RetInd' )}
                                            optionDisplayAttributes={['value']}
                                            optionKey="id"
                                            options={retailInd}
                                            placeholder=""
                                            selectedValue={selectedRetInd}
                                            isRequired={false}
                                        />
                                        <button className="primary-button" type="button" onClick={this.onFilterSearch.bind( this )}>
                                            <span> Filter </span>
                                        </button>
                                        <button type="button" onClick={this.onClear.bind( this )}>
                                            <span> Clear </span>
                                        </button>

                                    </div>
                                )}
                            </div>
                            { results !== null && (
                                <TransactionReallocationLogTable
                                    results={results}
                                    transactionLog={transactionLog}
                                    deereAtp={deereAtp}
                                    onSelectOrderNumber={this.onSelectOrderNumber.bind( this )}
                                />
                            )}

                        </section>
                    )}
                    { selectedOrderNumber !== 0 && (
                        <section className="section-container">
                            <div className="blurb-section">
                                <span className="back-link" onClick={() => this.onSelectOrderNumber( 0, 0 )}> <i className="fa fa-angle-double-left" /> Back to Results</span>
                                <Breadcrumbs crumbs={crumbs} />

                            </div>
                            <OrderInformation
                                order={selectedOrderNumber}
                                transnumber={selectedtransNumber}
                            />
                        </section>
                    )}
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

TransactionRellocationLog.displayName = 'TransactionRellocationLog';
TransactionRellocationLog.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    transactionLog: PropTypes.bool,
    deereAtp: PropTypes.bool,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( TransactionRellocationLog ) );
